import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDoubleDown,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faAngleDoubleUp,
  faAngleDown,
  faAngleRight,
  faArrowCircleLeft,
  faCheck,
  faAngleUp,
  faCrosshairs,
  faExternalLinkAlt,
  faFilePdf,
  faHome,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faPaperPlane,
  faPhone,
  faRoute,
  faSearch,
  faSpinner,
  faTimes,
  faWindowClose
} from "@fortawesome/free-solid-svg-icons";

import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faAngleDoubleDown,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faArrowCircleLeft,
  faAngleDoubleUp,
  faAngleDown,
  faAngleRight,
  faCheck,
  faAngleUp,
  faCrosshairs,
  faExternalLinkAlt,
  faFilePdf,
  faHome,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faPaperPlane,
  faPhone,
  faRoute,
  faSearch,
  faSpinner,
  faTimes,
  faWindowClose,
  faFacebookF,
  faTwitter
);

// const brands = require("@fortawesome/fontawesome-free-brands");
// flibrary.add(brands);

Vue.component("font-awesome-icon", FontAwesomeIcon); // Use the icon component anywhere in the app
Vue.config.productionTip = false;
